import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@chakra-ui/react'

import {useItemVariant} from '/overrides/app/components/item-variant'
import {getProductTag} from '/overrides/app/utils/product-tags'
import {useTranslationHelpers} from '../../hooks'

/**
 * In the context of a cart product item variant, this component renders
 * a promotion text if there are active promotions for the product.
 */
const ItemPromotionBadge = ({...props}) => {
    const variant = useItemVariant() ?? {}
    const {tCart} = useTranslationHelpers()

    const tag = getProductTag(variant, tCart)

    if (!tag) {
        return null
    }

    return (
        <Text
            fontSize="xs"
            fontWeight="normal"
            color={tag.color}
            textTransform={tag.type === 'promotional' ? 'none' : 'uppercase'}
            {...props}
        >
            {tag.text}
        </Text>
    )
}

ItemPromotionBadge.displayName = 'ItemPromotionBadge'

ItemPromotionBadge.propTypes = {}

export default ItemPromotionBadge
